import React, { useEffect, useState } from "react";
import { InputNumberPadrao } from "./Base";
import InputMask from "./InputMask";
import { InputNumero, InputNumeroPercent } from "./InputNumero";
import { ExclamationCircleFilled } from "@ant-design/icons";

export default function InputBlur({ value, onChange, type, ...props }) {
    const [valor, setValor] = useState(value);
    const keyPress = e => { if (e.keyCode === 13) onChange(valor); };

    useEffect(() => setValor(value), [value]);

    if (type === "masked") return <InputMask onChange={v => setValor(v.target.value)} onBlur={() => onChange(valor.replace(".", "").replace("_", "").replace(".", ""))} value={valor} {...props} />;
    if (type === "percent") return <InputNumeroPercent precision={2} value={valor} onKeyDown={keyPress} onChange={setValor} onBlur={() => onChange(valor)} {...props} />;
    if (type === "number") return <InputNumberPadrao value={valor} onKeyDown={keyPress} onChange={setValor} onBlur={() => onChange(valor)} {...props} />;
    if (type === "int") return <InputNumberPadrao precision={0} value={valor} onKeyDown={keyPress} onChange={setValor} onBlur={() => onChange(valor)} {...props} />;
    if (type === "lowernumber") return <span style={{ position: 'relative' }}><InputNumberPadrao value={valor} onKeyDown={keyPress} onChange={v => {
        setValor(v);

        if (v > value)
            onChange(v);
    }} onBlur={() => onChange(valor)} {...props} />
        {(valor < value) && <ExclamationCircleFilled style={{ position: "absolute", top: -3, right: -10 }} className="cor-danger" />}
    </span>;

    return <InputNumero value={valor} onChange={setValor} onBlur={() => onChange(valor)} {...props} />;
}